const dependentParamsAreSet = dependentParams =>
  dependentParams
    ? Object.values(dependentParams).every(param => ![null, undefined, ''].includes(param)) // eslint-disable-line
    : true;

export default dependentParamsAreSet;
